export const getLogged = ({ auth }) => auth.logged;
export const getLoading = ({ auth }) => auth.loading;
export const getUser = ({ auth }) => auth.user;
